import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";
import {FulfillmentSubTypeType} from "../../types/fulfillment-sub-type.type";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {FulfillmentDialogService} from "../../services/fulfillment-dialogs-service.service";
import {FulfillmentStepModel} from "../../models/fulfillment-step.model";

export class FulfillmentLineStepInfoComponent implements IController {

  fulfillmentId: string;
  fulfillment: any;
  step: FulfillmentStepModel;
  stepNumber: any;
  index: number;
  relations: any;
  isOpen: boolean;
  isMatchFilter: boolean;
  selectedKeys: any;
  excludeMode: boolean;
  isShowCheckbox: boolean;
  stepPriceInfo: any;
  onDispatch: Function;
  onSplit: Function;
  onAutoAssign: Function;
  onAssignRoute: Function;
  onAssignAgent: Function;
  onCancelService: Function;
  onCancelAttempt: Function;
  onToggleViewStep: Function;
  onToggleSelect: Function;
  onAddNote: Function;
  onCreateRoute: Function;
  onAssignResourceAllocation: Function;
  onCompleteManually: Function;
  onReset: Function;
  onDispatchExternal: Function;
  onCancelStep: Function;

  // public step: any;
  public fulfillmentSubTypeType: typeof FulfillmentSubTypeType = FulfillmentSubTypeType;
  public plannedPackagesCount: number;
  public executedPackagesCount: number;
  public lastAttempt: any;
  public pickupServiceAreaNames: string[];
  public destinationServiceAreaNames: string[];

  constructor(private $fulfillmentStep, private $scope: IScope, private fulfillmentDialogService: FulfillmentDialogService, private commonsDialogService: CommonsDialogService, private commonsService: CommonsService) {
  }

  $onInit() {
    if (this.step) {
      this._initFulfillmentStepData();
    }
  }

  $onChanges(changes) {
    if (changes.stepId && !changes.stepId.isFirstChange() || changes.fulfillmentId && !changes.fulfillmentId.isFirstChange()) {
      if (this.step) {
        this._initFulfillmentStepData();
      }
    }
  }

  private _initFulfillmentStepData() {
        this._initStepPackagesData(this.step);
        this.step.stepNumber = this.stepNumber;
        this.lastAttempt = _.find(this.step.attempts, (a) => {
          return a.referenceId === this.step.referenceId;
        });

        if(!!this.step.pickup?.location?.address?.areaIdToNameMap) {
          this.pickupServiceAreaNames = _.uniq(Object.values(this.step.pickup.location.address.areaIdToNameMap));
        }
        if(!!this.step.destination?.location?.address?.areaIdToNameMap) {
          this.destinationServiceAreaNames = _.uniq(Object.values(this.step.destination.location.address.areaIdToNameMap));
        }
  }

  getStepNumberByIndex(id) {
    return parseInt(id.at(-1)) + 1;
  }

  onToggleSelectStep() {
    this.step.matchFilter = this.isMatchFilter;
    this.onToggleSelect({step: this.step})
  }

  onOpenAttemptInfoDialog(attempt) {
    this.commonsDialogService.attemptInfoDialog(undefined, attempt.subType, this.fulfillmentId, this.step, this.stepPriceInfo, attempt);
  }

  onViewPods(fulfillmentSteps, event) {
    this.fulfillmentDialogService.identificationsImages(fulfillmentSteps, 'Manage Leg PODs');
  }

  private _initStepPackagesData(step) {
    this.plannedPackagesCount = 0;
    this.executedPackagesCount = 0;

    _.forEach(step.items, i => {
      this.plannedPackagesCount += i.count;
      if (!_.isUndefined(i.actualCount)) {
        this.executedPackagesCount += i.actualCount
      } else {
        this.executedPackagesCount += i.count
      }
    })
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLineStepInfo', {
    bindings: {
      fulfillmentId: '<',
      fulfillment: '<',
      step: '<',
      stepNumber: '<',
      relations: '<',
      isOpen: '<',
      isMatchFilter: '<?',
      selectedKeys: '<',
      excludeMode: '<',
      isShowCheckbox: '<',
      stepPriceInfo: '<',
      onToggleSelect: '&',
      onToggleViewStep: '&',
      onDispatch: '&',
      onSplit: '&',
      onAutoAssign: '&',
      onAssignAgent: '&',
      onAssignResourceAllocation: '&',
      onAssignRoute: '&',
      onCancelService: '&',
      onCancelAttempt: '&',
      onAddNote: '&',
      onCreateRoute: '&',
      onCompleteManually: '&',
      onReset: '&',
      onDispatchExternal: '&',
      onCancelStep: '&'
    },
    template: require('./fulfillment-line-step-info.html').default,
    controller: FulfillmentLineStepInfoComponent
  });
